"use strict";

exports.__esModule = true;
exports.MessageClassify = void 0;
var _TranslatorContext = require("../../../Core/Translator/TranslatorContext");
var _react = _interopRequireWildcard(require("react"));
var _utils = require("../../utils");
var _Condition = require("../../Condition");
var _vimanaTypes = require("@vimana/vimana-types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var MessageClassify = exports.MessageClassify = function MessageClassify(_ref) {
  var condition = _ref.condition,
    updateCondition = _ref.updateSelf;
  var _useContext = (0, _react.useContext)(_TranslatorContext.TranslatorContext),
    translate = _useContext.translate;
  var _condition$message = condition.message,
    message = _condition$message === void 0 ? {} : _condition$message;
  var updateSelf = function updateSelf(message) {
    return updateCondition(Object.assign({}, condition, {
      message: message
    }));
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Condition.NativeCodeFilter, {
    isOpen: message.nativeCode,
    setOpen: function setOpen(nativeCode) {
      return updateSelf(message.nativeCodeValues ? Object.assign({}, message, {
        nativeCode: nativeCode
      }) : Object.assign({}, message, {
        nativeCode: nativeCode,
        nativeCodeValues: [""]
      }));
    },
    values: message.nativeCodeValues,
    setValues: function setValues(nativeCodeValues) {
      return updateSelf(Object.assign({}, message, {
        nativeCodeValues: nativeCodeValues
      }));
    },
    operator: message.nativeCodeOperator,
    setOperator: function setOperator(nativeCodeOperator) {
      return updateSelf(Object.assign({}, message, {
        nativeCodeOperator: nativeCodeOperator
      }));
    }
  }), /*#__PURE__*/_react["default"].createElement(_Condition.ConditionTextFilter, {
    isOpen: message.conditionText,
    setOpen: function setOpen(conditionText) {
      return updateSelf(message.conditionTextValues ? Object.assign({}, message, {
        conditionText: conditionText
      }) : Object.assign({}, message, {
        conditionText: conditionText,
        conditionTextValues: [""]
      }));
    },
    values: message.conditionTextValues,
    setValues: function setValues(conditionTextValues) {
      return updateSelf(Object.assign({}, message, {
        conditionTextValues: conditionTextValues
      }));
    },
    operator: message.conditionTextOperator,
    setOperator: function setOperator(conditionTextOperator) {
      return updateSelf(Object.assign({}, message, {
        conditionTextOperator: conditionTextOperator
      }));
    }
  }), !(0, _utils.validateMessageFilter)(condition) ? /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      color: "rgb(194, 48, 48)"
    }
  }, translate("EnrichEditorUI.ClassifyConfig.Validation.FilterRequired", "At least one type of filters is required")) : null);
};